<ifc-app-scroll-container class="scroll-container" [widgetsWithTopHeader]="true">
    <form [formGroup]="form">
          <div class="flex column single-card">
            <ng-container *ngTemplateOutlet="formFields"></ng-container>
         </div>

      <ng-template #formFields>
        <div class="form-row">
          <mat-form-field appearance="outline" class="half-width from-field">
            <mat-label>Facility name</mat-label>
            <mat-error *ngIf="form.get('name').errors | hasControlError:['required']">Facility name is required</mat-error>
            <input
              matInput
              formControlName="name"
              type="text"
              placeholder="Facility name"
            />
          </mat-form-field>

          <div class="half-width align-checkbox">
            <mat-checkbox color="primary" formControlName="isDefault" >
              Default facility
            </mat-checkbox>
          </div>

        </div>

        <div class="form-row">

          <mat-form-field appearance="outline" class="from-field">
            <mat-label>Products</mat-label>
            <mat-error *ngIf="form.get('allowedProducts').errors | hasControlError:['required']">At least one product have to be selected</mat-error>
            <mat-select multiple formControlName="allowedProducts" placeholder="All" >
              <mat-option *ngFor="let option of productTypeOptions" [value]="option.value">{{option.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="from-field">
            <mat-label>Loan limit</mat-label>
            <mat-error *ngIf="form.get('maximumAcceptableLoanCreditLimit').errors | hasControlError:['required']">Loan limit is required</mat-error>
            <mat-error *ngIf="form.get('maximumAcceptableLoanCreditLimit').errors | hasControlError:['min', 'max']">Loan limit must be between 0.01 and 9999999999.99</mat-error>
            <input matInput formControlName="maximumAcceptableLoanCreditLimit" type="text"  inputmode="numeric" currencyMask [options]="{ precision: '2'}" autocomplete="off"  [disabled]="!data?.isWriteAllowed">
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="from-field">
            <mat-label>Borrowing capacity</mat-label>
            <mat-error *ngIf="form.get('borrowingCapacity').errors | hasControlError:['required']">Borrowing capacity is required</mat-error>
            <mat-error *ngIf="form.get('borrowingCapacity').errors | hasControlError:['min', 'max']">Borrowing capacity must be between 0.01 and 9999999999.99</mat-error>
            <input matInput formControlName="borrowingCapacity" type="text"  inputmode="numeric" currencyMask [options]="{ precision: '2'}" autocomplete="off">
          </mat-form-field>

          <mat-form-field appearance="outline" class="from-field">
            <mat-label>Status</mat-label>
            <mat-select
              formControlName="active"
            >
              <mat-option
                *ngFor="let option of FacilitiesActiveLabelValues"
                [value]="option.value"
              >
                {{ option.label }}
              </mat-option>
            </mat-select>
            <mat-error>Please select a status.</mat-error>
          </mat-form-field>
        </div>

        <div formGroupName="outboundBankAccount">
          <mat-header class="header">Operational account - outbound</mat-header>
          <ng-container *ngTemplateOutlet="operationalAccount; context: {inputFormGroup: form.controls.outboundBankAccount, isWriteAllowed: data?.isWriteAllowed}" ></ng-container>
        </div>


        <div formGroupName="inboundBankAccount">
          <mat-header class="header">Operational account - inbound</mat-header>

          <mat-checkbox color="primary" class="same-as-checbox"
            formControlName="sameAsOutbound">Same as outbound</mat-checkbox>
          <div *ngIf="!hideInbound">
            <ng-container *ngTemplateOutlet="operationalAccount; context: {inputFormGroup: form.controls.inboundBankAccount, isWriteAllowed: data?.isWriteAllowed}" ></ng-container>
          </div>
        </div>

        <div class="form-row" *ngIf="showLenders">
          <div formGroupName="seniorLenders" class="half-width">
            <mat-header class="header">Senior lenders</mat-header>
            <ng-container *ngTemplateOutlet="lendersTemplate; context: {
              inputFormGroup: form.controls.seniorLenders,
              isWriteAllowed: data?.isWriteAllowed,
              lenderType: 'Senior',
              lendersArray: seniorLendersArray,
              addLender: addSeniorLender.bind(this),
              removeLender: removeSeniorLender.bind(this)
            }" ></ng-container>
          </div>

          <div formGroupName="mezzanineLenders" class="half-width">
            <mat-header class="header">Mezzanine lenders</mat-header>
            <ng-container *ngTemplateOutlet="lendersTemplate; context: {
              inputFormGroup: form.controls.mezzanineLenders,
              isWriteAllowed: data?.isWriteAllowed,
              lenderType: 'Mezzanine',
              lendersArray: mezzanineLendersArray,
              addLender: addMezzanineLender.bind(this),
              removeLender: removeMezzanineLender.bind(this)
            }" ></ng-container>
          </div>
        </div>

        <div class="flex row end-center">
          <ifc-app-bar-actions
            [menuMobileAllowed]="false"
          ></ifc-app-bar-actions>
        </div>
      </ng-template>

      <ng-template #operationalAccount let-inputFormGroup="inputFormGroup">
        <ng-container [formGroup]="inputFormGroup">
          <div class="form-row">
            <mat-form-field appearance="outline" class="from-field">
              <mat-label>Bank name</mat-label>
              <mat-error *ngIf="inputFormGroup.get('bankName').errors | hasControlError:['required']">Bank name is required</mat-error>
              <input
                matInput
                formControlName="bankName"
                type="text"
                placeholder="Bank name"
              />
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" class="from-field">
              <mat-label>Routing number</mat-label>
              <mat-error *ngIf="inputFormGroup.get('routingNumber').errors | hasControlError:['required']">Routing number is required</mat-error>
              <mat-error *ngIf="inputFormGroup.get('routingNumber').errors | hasControlError:['minlength', 'maxlength']">Routing number have to be 9 digits long</mat-error>
              <input
                matInput
                formControlName="routingNumber"
                type="text"
                mask="000000000"
                placeholder="Routing number"
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="from-field">
              <mat-label>Account number</mat-label>
              <mat-error *ngIf="inputFormGroup.get('accountNumber').errors | hasControlError:['required']">Account number is required</mat-error>
              <input
                matInput
                formControlName="accountNumber"
                type="text"
                placeholder="Account number"
                numbersOnly
              />
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" class="from-field">
              <mat-label>Bank NACHA location</mat-label>
              <mat-error *ngIf="inputFormGroup.get('bankNachaLocation').errors | hasControlError:['required']">Bank NACHA location is required</mat-error>
              <input
                matInput
                formControlName="bankNachaLocation"
                type="text"
                placeholder="Bank NACHA location"
              />
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" class="from-field">
              <mat-label>Company ACH code</mat-label>
              <mat-error *ngIf="inputFormGroup.get('companyAchCode').errors | hasControlError:['required']">Company ACH code is required</mat-error>
              <mat-error *ngIf="inputFormGroup.get('companyAchCode').errors | hasControlError:['maxlength']">Company ACH code can't be longer than 10 characters</mat-error>
              <input
                matInput
                formControlName="companyAchCode"
                type="text"
                placeholder="Company ACH code"
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="from-field">
              <mat-label>SEC code</mat-label>
              <mat-error *ngIf="inputFormGroup.get('secCode').errors | hasControlError:['required']">SEC code is required</mat-error>
              <mat-select formControlName="secCode" placeholder="SEC code">
                <mat-option *ngFor="let option of secCodeOptions" [value]="option.value">{{option.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" class="from-field">
              <mat-label>Company entry description</mat-label>
              <mat-error *ngIf="inputFormGroup.get('companyEntryDescription').errors | hasControlError:['required']">Company entry description is required</mat-error>
              <mat-error *ngIf="inputFormGroup.get('companyEntryDescription').errors | hasControlError:['maxlength']">Company entry description can't be longer than 10 characters</mat-error>
              <input
                matInput
                formControlName="companyEntryDescription"
                type="text"
                placeholder="Company entry description"
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="from-field">
              <mat-label>NACHA destination name</mat-label>
              <mat-hint>Bank name is used when empty</mat-hint>
              <mat-error *ngIf="inputFormGroup.get('nachaDestinationName').errors | hasControlError:['maxlength']">NACHA destination name can't be longer than 23 characters</mat-error>
              <input
                matInput
                formControlName="nachaDestinationName"
                type="text"
                placeholder="NACHA destination name"
              />
            </mat-form-field>
          </div>

        </ng-container>
      </ng-template>

      <ng-template #lendersTemplate
        let-inputFormGroup="inputFormGroup"
        let-lenderType="lenderType"
        let-lendersArray="lendersArray"
        let-addLender="addLender"
        let-isWriteAllowed="isWriteAllowed"
        let-removeLender="removeLender">
        <ng-container [formGroup]="inputFormGroup">
          <div class="form-row">
            <mat-form-field appearance="outline" class="from-field">
              <mat-label>{{ lenderType + ' lender percentage'}}</mat-label>
              <mat-error *ngIf="inputFormGroup.get('percentage').errors | hasControlError:['required']">{{ lenderType + ' lender percentage'}} is required</mat-error>
              <mat-error *ngIf="inputFormGroup.get('percentage').errors | hasControlError:['min', 'max']">Percentage must be between 0.01% and 100%</mat-error>
              <input matInput formControlName="percentage" type="text" [min]="0.01" [max]="100" inputmode="numeric" currencyMask [options]="{ precision: '2', suffix: '%', prefix:''}" autocomplete="off">
            </mat-form-field>
          </div>

          <div class="layout margin-bottom">
            <table
              class="space-between-rows mat-form-field"
              [ngClass]="{ 'lender-names-error-state': (lendersArray?.touched || lendersArray?.dirty) && lendersArray.errors | hasControlError:['required'] }"
            >

              <tr class="row-header">
                <td class="index"></td>
                <td class="item-title secondary-text">{{ lenderType + ' lender name'}}</td>
              </tr>

              <tr class="row" formArrayName="lendersNames"
                *ngFor="let lenderName of lendersArray.controls; index as i">
                <ng-container [formGroupName]="i">

                  <td class="index">{{i+1}}</td>

                  <td class="type-select">
                    <mat-form-field appearance="fill" class="mat-form-field-sm" subscriptSizing="dynamic">
                      <mat-error *ngIf="lenderName.get('lenderName').errors | hasControlError:['required']">Lender name is required</mat-error>
                      <input
                        matInput
                        formControlName="lenderName"
                        type="text"
                        placeholder="Lender name"
                    />
                    </mat-form-field>
                  </td>

                  <td class="delete" *ngIf="isWriteAllowed">
                    <button type="button" mat-icon-button (click)="removeLender(i)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>

                  <td class="index" *ngIf="!isWriteAllowed"></td>

                </ng-container>

              </tr>

              <tr class="row row--add-button" *ngIf="isWriteAllowed">
                <td>
                  <button type="button" color="primary" mat-icon-button class="mat-icon-button-lg add-button" (click)="addLender()">
                    <mat-icon>add_circle</mat-icon>
                  </button>
                </td>
              </tr>
            </table>
            <mat-error
              *ngIf="(lendersArray?.touched || lendersArray?.dirty) && lendersArray.errors | hasControlError:['required']"
              class="margin-bottom mat-error-lenders"
          >
            At least one {{ lenderType.toLowerCase() }} lender is required.
          </mat-error>
          </div>
        </ng-container>
      </ng-template>
    </form>
  </ifc-app-scroll-container>
